// MARK://dhk8/pos/pages/KdsPage
// The /kds route, rendered inside PosLayout (Agent A owns the shell + the role/
// license gate that pins a `cocina` user here when the org has KDS licensed).
//
// Behaviour: a screen first picks a station (or "todas"), then shows the Kitchen
// Display board (TicketBoard) — three columns, realtime via @dockethub/realtime (falls
// back to polling), optimistic transitions, new-ticket chime. Port of
// `sc-restaurant/apps/web/src/features/kds/KdsPage.tsx`, now backed by the absorbed
// `src/features/kds/*` (the former standalone `apps/dhk8-kds` lives here now).
//
// License/role gate contract (for Agent A — src/lib/role-license-gate.ts):
//   - When the active org has `licensed.kds === true` AND `user.role === 'cocina'`,
//     redirect ALL routes to `/kds` and hide other nav entries. The cocina user
//     can only ever see /kds (+ /login when unauthenticated).
//   - Other roles (cajero, gerente, admin) reach /kds normally via the side nav
//     when `licensed.kds === true`; if KDS is not licensed, hide the /kds nav entry
//     and 404/redirect the route.
//   - This page assumes the gate already ran: it does not re-check the license.

import { StationPicker, TicketBoard, useKdsStore } from '../features/kds/index.js'

export default function KdsPage() {
  const stationChosen = useKdsStore((s) => s.stationChosen)
  return stationChosen ? <TicketBoard /> : <StationPicker />
}
